import * as amplitude from '@amplitude/analytics-browser'

export const track = (event: string, data?: unknown) => {
  const isActive = useCookie('is_active', {
    expires: new Date(Date.now() + 1800000),
  })
  isActive.value = 'true'
  amplitude.logEvent(event, <Record<string, unknown>>data)
}

export const setUserId = (ati: string, email?: string) => {
  const identify = new amplitude.Identify().set('user_id', ati)
  if (email) {
    identify.set('user_email', email)
  }

  amplitude.setUserId(ati)
  amplitude.identify(identify)
}
